<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;IT Reports</h5>
  </div>

  <div class="container">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-4" *ngIf="hasAccess('Asset Physical Verification Report')">
          <div class="card shadow" style="align-items: center;">
            <div class="card-body ">
              <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:18px;"
                (click)="assetPhysicalVerificationClick()">
                Asset Physical Verification Report
              </div>
            </div>
          </div>
        </div>


        <div class="col-md-4" *ngIf="hasAccess('Asset Pop-up Confirmations')">
          <div class="card shadow" style="align-items: center;">
            <div class="card-body align-items-start">
              <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:18px;"
                (click)="assetpopupconfirmationClick()">
                Asset Pop-up Confirmations
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4" *ngIf="hasAccess('Asset History Report')">
          <div class="card shadow" style="align-items: center;">
            <div class="card-body align-items-start">
              <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:18px;"
                (click)="assetHistoryClick()">
                Asset History Report
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>